import { render, staticRenderFns } from "./EditInvestigatorDetail.vue?vue&type=template&id=0f83bdb9&scoped=true"
import script from "./EditInvestigatorDetail.vue?vue&type=script&lang=js"
export * from "./EditInvestigatorDetail.vue?vue&type=script&lang=js"
import style0 from "./EditInvestigatorDetail.vue?vue&type=style&index=0&id=0f83bdb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f83bdb9",
  null
  
)

export default component.exports